import { OriginApp, WidgetTheme } from '@wix/wix-help-widget-common/types';

// The origin→theme map lives in the shared lib so the widget shell
// (help-center-client) resolves exactly the same way this app does.
export { getWidgetTheme, isWidgetTheme, originToTheme } from '@wix/wix-help-widget-common/theme';

/**
 * A narrow deviation *within* a resolved theme, for host families that share a
 * theme but differ in a handful of product decisions. A variant owns no palette
 * of its own — components read it off ThemeTraits and change nothing but the
 * affected props, so everything else about the theme stays identical.
 */
export type WidgetVariant = 'bm';

// Business Manager and the dashboard surfaces that share its chrome.
const BM_ORIGINS: readonly string[] = [
  OriginApp.BusinessManager,
  OriginApp.AccountManager,
  OriginApp.SitesList,
];

/**
 * Resolved next to the theme so `origin` stops in this file, exactly as it does
 * for `getWidgetTheme` — downstream takes the resolved variant, never the origin.
 *
 * Harmony-on-BM only: the dashboard surfaces above render the Harmony theme with
 * neutral (`dark` skin) CTAs instead of the accented ones Editor 3 uses. Inert
 * until those hosts declare `theme: 'odeditor'`, since `originToTheme` maps them
 * to `default`.
 */
export const getWidgetVariant = (originApp: string | null, theme: WidgetTheme): WidgetVariant | null =>
  theme === 'odeditor' && originApp !== null && BM_ORIGINS.includes(originApp) ? 'bm' : null;
